function Tag({ text }) {
  return <span className="hero-tag">{text}</span>;
}

export default Tag;
